import classNames from 'classnames';
import CountAnimatedBadge from 'components/atoms/CountAnimatedBadge/CountAnimatedBadge.component';
import UseEffect from 'components/atoms/UseEffect';
import useUpdateSidebarDocCounts, {
  useSidebarState,
} from 'hooks/useUpdateSidebarDocCounts';
import type { FC } from 'react';
import { SidebarDocCountsKeysEnum } from 'store/sidebarState';

const NewRevenuesCount: FC<{ isActive?: boolean }> = ({ isActive }) => {
  const { state: sidebarState } = useSidebarState();
  const newlyAddedRevenuesCount =
    sidebarState?.[SidebarDocCountsKeysEnum.NewRevenuesCount];
  const updateSidebarCounts = useUpdateSidebarDocCounts();

  if (!newlyAddedRevenuesCount) return null;

  return (
    <UseEffect
      effect={() => {
        const id = setTimeout(
          () =>
            updateSidebarCounts(SidebarDocCountsKeysEnum.NewRevenuesCount, 0),
          3000,
        );

        return () => clearTimeout(id);
      }}
      key={String(newlyAddedRevenuesCount)}
      deps={[newlyAddedRevenuesCount]}
      render={() => (
        <CountAnimatedBadge
          count={`+${newlyAddedRevenuesCount}`}
          className={classNames(
            '!text-revenues-900 border-[1px] border-revenues-900',
            {
              '!bg-white': isActive,
              '!bg-revenues-100': !isActive,
            },
          )}
        />
      )}
    />
  );
};

export default NewRevenuesCount;
